module.exports = __webpack_public_path__ + "img/certificate-3.6e8dd4ae.png";